import React ,{Suspense} from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import store from "./store/store";

import { GoogleOAuthProvider } from '@react-oauth/google';

const root = document.getElementById("root");
ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <Suspense>
              <App />
          </Suspense>
      </GoogleOAuthProvider>
    </Provider>
  </BrowserRouter>
);
